import { withBrowserTextareaHeight } from '@/src/general/utils/withBrowserTextareaHeight'

import { IntentionForm as IntentionFormNative, type TIntentionFormProps } from './IntentionForm.shared'

export const IntentionForm = withBrowserTextareaHeight(IntentionFormNative)
export { TIntentionFormProps }
